import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const StandingsTable = ({ data, t_controls }) => {
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleRow = (teamId) => {
    const newExpandedRows = new Set(expandedRows);
    if (newExpandedRows.has(teamId)) {
      newExpandedRows.delete(teamId);
    } else {
      newExpandedRows.add(teamId);
    }
    setExpandedRows(newExpandedRows);
  };

  return (
    <div className="card-standing card-group-custom card-standing-index" 
         id="accordion1" 
         role="tablist" 
         aria-multiselectable="false">
      <div className="card-standing-caption">
        <div className="card-standing-position">{t_controls.position}</div>
        <div className="card-standing-caption-aside">
          <div className="card-standing-team">{t_controls.team}</div>
          <div className="card-standing-number">W</div>
          <div className="card-standing-number">L</div>
          <div className="card-standing-number">T</div>
          <div className="card-standing-diff">DIFF</div>
          <div className="card-standing-points">PTS</div>
        </div>
      </div>

      {data.map((team) => (
        <article key={team.team} className="card card-custom">
          <div className="card-standing-position card-standing-counter"></div>
          <div className="card-header" 
               id={`accordion1Heading${team.team}`} 
               role="tab">
            <div className="card-standing-team-item">
              <div className="card-standing-team">
                <div className="card-standing-team-figure">
                  <img src={team.logo} alt={team.team} />
                </div>
                <div className="card-standing-team-title">
                  <div className="card-standing-team-name">{team.team}</div>
                  <div className="card-standing-team-country"></div>
                </div>
              </div>
              <div className="card-standing-number">{team.wins}</div>
              <div className="card-standing-number">{team.losses}</div>
              <div className="card-standing-number">{team.ties}</div>
              <div className="card-standing-diff">{team.goals_scored - team.goals_conceded}</div>
              <div className="card-standing-points">{team.points}</div>
              <div className="card-standing-button">
                <a href="#"
                  className={classNames(
                    "card-standing-toogle material-icons-remove",
                    { 'collapsed': !expandedRows.has(team.team) }
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleRow(team.team);
                  }}
                  aria-expanded={expandedRows.has(team.team)}
                  aria-controls={`accordion1Collapse${team.team}`}
                />
              </div>
            </div>
          </div>

          <div
            className={classNames('collapse', {
              'show': expandedRows.has(team.team)
            })}
            id={`accordion1Collapse${team.team}`}
            role="tabpanel"
            aria-labelledby={`accordion1Heading${team.team}`}
          >
            <div className="card-body">
              <div className="card-standing-team-details">
                <div className="card-standing-game-status">
                  {t_controls.home}
                </div>
                <div className="card-standing-number">{team.home_won}</div>
                <div className="card-standing-number">{team.home_lost}</div>
                <div className="card-standing-number">{team.home_ties}</div>
              </div>
              <div className="card-standing-divider"></div>
              <div className="card-standing-team-details">
                <div className="card-standing-game-status">
                  {t_controls.away}
                </div>
                <div className="card-standing-number">{team.away_won}</div>
                <div className="card-standing-number">{team.away_lost}</div>
                <div className="card-standing-number">{team.away_ties}</div>
              </div>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};

StandingsTable.propTypes = {
  data: PropTypes.array.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default StandingsTable;